<template>
  <div>
    <div class="payment-page">
      <div class="titleMaxBox" v-if="show">
        <div>
          <img class="titleMax" src="@/assets/titleMax.png" alt="" />
          <p>Payment</p>
        </div>
      </div>
      <div style="padding: 1rem" v-if="show">
        <div class="topTMax">
          <div style="font-style: italic">Order will be closed in:</div>
          <div class="timer">
            <van-count-down
              :style="
                time == '9999'
                  ? 'color: #ffffff;font-size: 16px;'
                  : 'font-size: 16px;line-height: 25px;height: 25px;color: #da2f2f;font-weight:bold'
              "
              format="mm:ss"
              :time="time"
              @finish="onFinish"
            />
          </div>
        </div>

        <div class="mainBox">
          <div class="topT">
            <div class="moneyBox">
              <p
                style="
                  display: flex;
                  /* text-align: center; */
                  align-items: center;
                  justify-content: center;
                "
              >
                ₹
                <span v-show="form.orderAmount">{{ form.orderAmount }}</span>
                <van-loading
                  type="spinner"
                  v-show="!form.orderAmount"
                  style="color: #2a50ba"
                  vertical
                ></van-loading>
                <van-icon
                  v-if="form.orderAmount"
                  class="iconCopy"
                  name="column"
                  size="18pt"
                  style="margin-left: 3px; transform: translateY(20px)"
                  @click="copyText(2)"
                />
              </p>
              <p>The amount you need to pay</p>
            </div>

            <!-- <p style="color: #333333; margin-bottom: 26px">
              Use Mobile Scan code to pay
            </p> -->
          </div>

          <!-- <div class="qcBox">
            <van-image
              width="175pt"
              height="175pt"
              fit="fill"
              :src="formattedQrCode"
            />
  
            <div class="QRCodeBtns" v-debounce="QRCodeBtnsFun">Save QRCode</div>
          </div> -->

          <p class="methodBox">
            Method 1 (Mostly used)
            <span style="background: #fcf2e4; color: #f97824"
              ><img
                style="width: 12px; transform: translateY(2px)"
                src="@/assets/tis.png"
                alt=""
              />
              Discounted</span
            >
          </p>

          <div v-show="form.walletList">
            <div
              class="payBox"
              v-for="(item, index) in form.walletList"
              :key="index"
            >
              <div>
                <img
                  v-if="item.walletCode == 'paytm'"
                  class="img1"
                  src="@/assets/paytm.png"
                  alt=""
                />
                <img
                  v-if="item.walletCode == 'phonepe'"
                  class="img1"
                  src="@/assets/phonePe.jpg"
                  alt=""
                />

                <div class="payBoxTips">
                  <p>
                    {{ item.walletCode == "paytm" ? "Paytm" : item.walletCode }}
                  </p>
                  <p style="font-style: italic">Convenient and fastest</p>
                </div>
              </div>
              <div class="payBtnBox">
                <p v-if="item.walletCode == 'paytm'" style="font-style: italic">
                  Discounted price
                  <span style="font-style: normal">{{
                    form.randomAmount
                  }}</span>
                </p>
                <!-- <div
                  :class="
                    dialogFlag
                      ? 'payBtn pulsing-box dNone'
                      : 'payBtn pulsing-box'
                  "
                  :style="
                    item.walletCode == 'paytm'
                      ? 'transform: translateY(4px)'
                      : ''
                  "
                  @click="payOne(9, item.clickUrl)"
                >
                  PAY
                </div> -->
                <div
                  :style="
                    item.walletCode == 'paytm'
                      ? 'transform: translateY(4px);display: flex'
                      : 'display: flex'
                  "
                >
                  <div class="payBtn" @click="payOne(9, item.clickUrl)">
                    PAY
                    <img src="@/assets/click4.gif" alt="" class="clickCss" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 下面这部分为占位模块，没有功能 -->
          <div v-show="!form.walletList" class="payBox">
            <div>
              <img class="img1" src="@/assets/paytm.png" alt="" />

              <div class="payBoxTips">
                <p>Paytm</p>
                <p style="font-style: italic">Convenient and fastest</p>
              </div>
            </div>
            <div class="payBtnBox">
              <p style="font-style: italic; display: flex">
                Discounted price
                <span style="font-style: normal">
                  <van-loading
                    type="spinner"
                    v-show="form.orderAmount"
                    style="color: #2a50ba"
                    size="12px"
                    vertical
                  ></van-loading>
                </span>
              </p>
              <div style="transform: translateY(4px); display: flex">
                <div class="payBtn">
                  PAY
                  <img src="@/assets/click4.gif" alt="" class="clickCss" />
                </div>
              </div>
            </div>
          </div>

          <p class="methodBox">Method 2</p>
          <div class="payBox">
            <div>
              <img class="img1" src="@/assets/sao.png" alt="" />
              <div class="payBoxTips">
                <p>QRcode</p>
                <p style="font-style: italic">
                  Scan QRcode with the wallet app
                </p>
              </div>
            </div>
            <div
              class="payBtn"
              @click="payOne(1)"
              :style="!QRcodeFlag ? 'background: #e7e7e7' : ''"
            >
              PAY
            </div>
            <!-- <div>
              <img class="toS" src="@/assets/right.png" alt="@/assets/sao.png" />
            </div> -->
          </div>

          <div v-if="paymentMethodCopyUpiFlag">
            <p class="methodBox" v-if="form.paymentMethodCopyUpi != 2">
              Method 3
            </p>
            <div
              class="payBox"
              style="display: block"
              v-if="form.paymentMethodCopyUpi != 2"
            >
              <div class="payBoxMIN">
                <div>
                  <img class="img1" src="@/assets/upiMax.png" alt="" />
                  <div class="payBoxTips">
                    <p>Manual transfer</p>
                    <p style="font-style: italic">Copy UPl and fill in UTR</p>
                  </div>
                </div>

                <div
                  class="payBtn"
                  @click="payOne(3)"
                  :style="!manualTransferFlag ? 'background: #e7e7e7' : ''"
                >
                  PAY
                </div>
                <!-- <div>
                  <img
                    class="toS"
                    src="@/assets/right.png"
                    alt="@/assets/sao.png"
                  />
                </div> -->
              </div>
              <!-- <p class="payBoxB">
                If paying by this method, please copy and submit the UTR to us.
              </p> -->
            </div>
          </div>
          <div class="payTMS">
            <img src="@/assets/payTMS.png" alt="" />
          </div>
        </div>

        <!-- <p style="font-size: 14px; margin-top: 30px; margin-bottom: 14px">
          <span style="margin-right: 12px">UTR</span
          ><span style="color: #ff0000" @click="noFlase"
            >How to find UTR? Click here.</span
          >
        </p> -->

        <!-- <div class="btnBox">
          <van-field
            style="
              height: 44px;
              line-height: 44px;
              border-radius: 10px;
              padding: 0 14px;
            "
            v-model="utrValue"
            placeholder="Input 12-digit here"
          />
          <div v-debounce="submitPayment">Submit Ref Number</div>
        </div> -->

        <div class="txtTips">
          <p><span></span> Important Reminder</p>
          <div class="txtBoxMax">
            <div>
              <p>1.</p>
              <p>Please make sure you have installed the app.</p>
            </div>
            <div>
              <p style="color: #e93728 !important">2.</p>
              <p style="color: #e93728 !important">
                Don't pay for the same link repeatedly.
              </p>
            </div>
            <div>
              <p>3.</p>
              <p>
                Please select the payment method you need and make sure your
                phone has the corresponding wallet software installed
              </p>
            </div>
          </div>
        </div>

        <van-action-sheet v-model="showOne" title=" ">
          <div class="content">
            <div v-if="showNum == 1">
              <p class="mSy" style="color: #2a50ba; font-size: 36px">
                ₹ {{ form.orderAmount }}
              </p>
              <p class="showOneTxt" style="margin-bottom: 12px">
                Tip: Please make sure your payment amount is consistent with the
                order amount, otherwise your order may fail
              </p>
              <p class="showOneTitle">1.Copy the below given UPI</p>

              <div class="showOneSearch">
                <van-field
                  style="
                    border: 0.5px solid #c5c3c3;
                    border-radius: 5px;
                    flex: 1;
                    margin-right: 6.5px;
                    height: 44px;
                    line-height: 44px;
                    padding: 0 14px;
                  "
                  v-model="form.upiAccountHide"
                  placeholder=""
                  disabled
                />

                <div @click="copyUpiId">
                  <div
                    class="showOneCopy"
                    @click="copyText(1)"
                    :style="
                      !copyUpiIdFlag
                        ? 'background: #e7e7e7;line-height: 44px'
                        : 'line-height: 44px'
                    "
                  >
                    COPY
                  </div>
                </div>
              </div>

              <p class="showOneTxt">
                Tip: Don't save the UPI, get new UPI every time.
              </p>

              <p class="showOneTitle">2. Need to enter your 12 Ref No(UTR)</p>

              <div
                class="showOneSearch"
                style="border: 0.5px solid #c5c3c3; border-radius: 5px"
              >
                <!-- <div class="showOneSearchLabel">
                  <P>*</P>
                  <p style="line-height: 2.3rem">UTR</p>
                </div> -->
                <van-field
                  style="
                    flex: 1;
                    height: 44px;
                    line-height: 44px;
                    padding: 0 14px;
                    border-radius: 5px;
                  "
                  v-model="utrValue"
                  placeholder="input UTR number"
                />
              </div>

              <p class="test1" @click="noFlase">How to Find Your UTR?</p>
              <p class="showOneTxt">
                Tip: Open your UPI wallet and complete the transfer Record your
                reference No.(UTR) after payment.
              </p>
            </div>

            <div v-if="showNum == 2">
              <div class="qrCodeImgs">
                <div>
                  <p
                    class="mSy"
                    style="margin-bottom: 10px; font-size: 36px; color: #2a50ba"
                  >
                    ₹
                    {{
                      form.firstCheckOutQrCodeReliefSwitch == 1
                        ? form.randomAmount
                        : form.orderAmount
                    }}
                  </p>
                  <p
                    class="mSy mSyTwo"
                    style="font-size: 15px; margin-bottom: 10px; color: #999999"
                    v-if="form.firstCheckOutQrCodeReliefSwitch == 1"
                  >
                    ₹ <s> {{ form.orderAmount }}</s>
                  </p>
                </div>

                <p
                  style="
                    margin-bottom: 0;
                    font-size: 14px;
                    color: #333333;
                    font-weight: bold;
                  "
                >
                  Use Mobile Scan code to pay
                </p>

                <!-- <van-image width="154pt" height="154pt" fit="fill" :src="formattedQrCode" /> -->
                <van-image
                  width="154pt"
                  height="154pt"
                  fit="fill"
                  :src="formattedQrCode"
                  style="display: block; margin: 0 auto"
                />

                <p
                  class="saveQR"
                  @click="QRCodeBtnsFun"
                  :style="!saveQRferFlag ? 'background: #e7e7e7' : ''"
                >
                  Save QRcode
                </p>
              </div>

              <div class="showOneSearchTwo">
                <div class="showOneSearchLabelNews">
                  <p>UTR</p>
                  <p>(Optional)</p>
                </div>
                <van-field
                  style="
                    flex: 1;
                    height: 44px;
                    line-height: 44px;
                    padding: 0 14px;
                    border: 0.5px solid #c5c3c3;
                    border-radius: 5px;
                    text-align: center;
                  "
                  v-model="utrValue"
                  placeholder="input UTR number"
                />
              </div>

              <p class="showOneTxt">
                Tip: Open your UPI wallet and complete the transfer Record your
                reference No.(UTR) after payment.
              </p>

              <p class="test1" @click="noFlase">How to Find Your UTR?</p>
            </div>

            <div v-if="showNum == 9">
              <div>
                <p class="mSy" style="margin-bottom: 6px; color: #2a50ba">
                  ₹
                  {{ form.randomAmount }}
                </p>
                <p class="mSy mSyTwo" style="color: #2a50ba">
                  ₹ <s> {{ form.orderAmount }}</s>
                </p>
              </div>

              <p class="payTxt">Payment via Paytm, Limited-Time Offer</p>
            </div>

            <div class="btnFun" v-if="showNum == 9" @click="payOne(9)">
              TO PAY
            </div>
            <div
              class="btnFun"
              v-if="showNum != 9"
              v-debounce="submitPayment"
              :style="!submitUTRFlag ? 'background: #e7e7e7' : ''"
            >
              Submit UTR
            </div>
          </div>
        </van-action-sheet>
      </div>
      <div v-else>
        <div class="sBox" v-if="status == 'wait'">
          <div v-if="orderStatus == ''" class="sBox">
            <div class="circle">
              <div class="dots">
                <div
                  v-for="n in 8"
                  :key="n"
                  class="dot"
                  :style="getDotStyle(n)"
                ></div>
              </div>
              <div class="countdown">
                {{ countdown }}
              </div>
            </div>
            <p
              style="
                font-family: Source Sans Variable;
                font-weight: 400;
                text-align: center;
                font-size: 15px;
                color: #333333;
              "
            >
              UTR submitted successfully and <br />
              is being confirmed
            </p>
          </div>
          <div v-if="orderStatus == 1" class="sBox">
            <van-image
              width="100"
              height="100"
              :src="require('../assets/success@2x.png')"
            />
            <p class="sp">Your payment is successful!</p>
          </div>
          <div v-else class="sBox">
            <van-image
              width="100"
              height="100"
              :src="require('../assets/时间@2x.png')"
            />
            <p class="sp">
              The payment result may be delayed,<br />
              we will process it within 10 minutes
            </p>
          </div>
        </div>
      </div>
      <div class="sBox" v-if="status == 'timeout'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">Payment timed out, please try again</p>
      </div>

      <div class="sBox" v-if="status == 'prompt'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">
          Payment submission is successful, please wait patiently for the
          payment result
        </p>
      </div>

      <div class="sBox" v-if="status == 'promptTwo'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">
          {{ h5PayOrderQueryMsg }}
        </p>
      </div>

      <div class="sBox" v-if="status == 'err'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">{{ msg }}</p>
      </div>
    </div>

    <div class="dBox" v-if="dialogFlag">
      <div class="nos" @click="noFlase">X</div>
      <div>
        <p>MobiKwik</p>
        <img src="@/assets/to1.jpg" alt="" />
        <p>Freecharge</p>
        <img src="@/assets/to2.jpg" alt="" />
        <p>Gpay</p>
        <img src="@/assets/to3.jpg" alt="" />
        <p>PayTM</p>
        <img src="@/assets/to4.jpg" alt="" />
        <p>PhonePe</p>
        <img src="@/assets/to5.jpg" alt="" />
      </div>
    </div>

    <div class="loadingBox" v-if="loadingFlag">
      <div
        style="
          margin-top: 50vh;
          transform: translate(-50%, -50%);
          width: 120px;
          height: 120px;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 14px;
          margin-left: 50vw;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <!-- 旋转类型+文字 -->
        <van-loading type="spinner" style="color: #fff" vertical
          >loading...</van-loading
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  h5CashRegisterGetUpiV2,
  h5PayOrderQuery,
  h5CheckOutClickV2,
  h5CheckOutUtrSubmit,
  h5OrderBuriedPointCreate,
} from "@/api";
import { Button, Dialog } from "vant";
import Vue from "vue";
Vue.use(Button);
import { Icon } from "vant";
Vue.use(Icon);
import { Field } from "vant";
Vue.use(Field);
import { CountDown } from "vant";
Vue.use(CountDown);
import { Image as VanImage } from "vant";
Vue.use(VanImage);
import { Toast } from "vant";
Vue.use(Toast);
import { ActionSheet } from "vant";
Vue.use(ActionSheet);
import { Loading } from "vant";
Vue.use(Loading);

import Clipboard from "clipboard";

export default {
  data() {
    return {
      time: 9999,
      status: "默认",
      upiId: "",
      headers: {
        "X-Plat-Order-Id": this.$route.query.orderId,
        "X-Sign": this.$route.query.sign, // 使用组件中的动态值
      },
      form: {},
      show: true,
      countdown: 10,
      interval: null,
      intervalStatus: null,
      orderStatus: "",

      dialogFlag: false,
      msg: "",

      showOne: false,

      utrValue: "",

      showNum: 1,

      url: "",

      statusFlag: false,

      loadingFlag: false,

      btnFlag: false,

      // 避免出现paymentMethodCopyUpi为2时候页面闪一下的情况
      paymentMethodCopyUpiFlag: false,

      QRcodeFlag: true,
      manualTransferFlag: true,
      saveQRferFlag: true,
      submitUTRFlag: true,
      copyUpiIdFlag: true,

      h5PayOrderQueryMsg: "",

      upiAccount: "",

      maxRetries: 1,
      statusT: "",

      toJumpUrl: "",
    };
  },
  methods: {
    noFlase() {
      this.showOne = false;
      this.dialogFlag = !this.dialogFlag;
    },

    getDotStyle(index) {
      const angle = index * 45 * (Math.PI / 180); // 每个点之间的角度
      const radius = 30; // 半径
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      return {
        transform: `translate(${x}px, ${y}px)`,
        animation: `dot-animation 1.4s ease-in-out infinite ${index * 0.1}s`,
      };
    },
    startCountdown() {
      this.interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },
    async getStatus() {
      const res = await h5PayOrderQuery(
        {
          platOrderId: this.$route.query.orderId,
        },
        this.headers
      );

      if (res.status != 2) {
        clearInterval(this.interval);
        clearInterval(this.intervalStatus);
        this.orderStatus = res.status;
      }

      if (res.jumpUrl != "") {
        this.toJumpUrl = res.jumpUrl;
      }

      // 订单失败处理
      if (res.status == 3) {
        this.show = false;
        this.status = "err";
        this.msg = "Payment failed";
        return;
      }

      // 订单成功处理
      if (res.status == 1) {
        if (this.toJumpUrl != "") {
          window.open(this.toJumpUrl, "_blank");
        }
        this.show = false;
        this.status = "promptTwo";
        this.h5PayOrderQueryMsg = "Order successful";
        return;
      }

      if (res.status == 2 && this.countdown == 0) {
        this.orderStatus = 8;
      }
    },
    async getInfo() {
      const res = await h5CashRegisterGetUpiV2(
        {
          platOrderId: this.$route.query.orderId,
        },
        this.headers
      );

      if (res.status == "635") {
        if (this.maxRetries < 3) {
          this.loadingFlag = true;
          this.maxRetries++;
          setTimeout(async () => {
            return await this.getInfo();
          }, 1500);
          return;
        }
        this.statusT = 635;
        this.loadingFlag = false;
        this.show = false;
        this.status = "err";
        this.msg = "Please refresh the page and try again.";
        return;
      }

      // 链接已经被调起
      if (res.status == 3 && this.show != false) {
        Dialog.confirm({
          title: "prompt",
          message: "Have you completed the payment?",
          confirmButtonText: "Not paid yet", //取消按钮
          cancelButtonText: "Paid", //确定按钮
        })
          .then(() => {
            if (this.toJumpUrl != "") {
              window.open(this.toJumpUrl, "_blank");
            }
          })
          .catch(() => {
            this.show = false;
            this.status = "prompt";
          });
      }

      // 异常处理
      if (res.status == 600 || res.status == 620) {
        this.show = false;
        this.status = "err";
        this.msg = res.message;
        return;
      }

      this.form = res;

      this.paymentMethodCopyUpiFlag = true;

      this.h5OrderBuriedPointCreateFun(3);

      this.calculateTimeDifference(res.expireTime);
    },

    onFinish() {
      this.show = false;
      this.status = "timeout";
      clearInterval(this.intervalStatus);
    },

    calculateTimeDifference(params) {
      // 获取当前印度时间的 Date 对象
      const currentTime = (() => {
        const indianTimeString = new Date().toLocaleString("en-US", {
          timeZone: "Asia/Kolkata",
        });
        return new Date(indianTimeString);
      })();

      // 订单有效时间
      const expireTime = new Date(params.replace(" ", "T"));

      // 计算时间差，单位为毫秒
      const timeDifference = expireTime - currentTime;

      // 将结果赋值给 time
      this.time = timeDifference;
    },

    copyUpiId() {
      if (this.copyUpiIdFlag == false) {
        return false;
      }

      this.copyUpiIdFlag = false;

      h5CheckOutClickV2(
        { platOrderId: this.$route.query.orderId, payMethod: 1 },
        this.headers
      )
        .then((res) => {
          this.copyUpiIdFlag = true;
          this.h5OrderBuriedPointCreateFun(14);

          this.upiAccount = res.upiAccount;
        })
        .catch((err) => {
          this.copyUpiIdFlag = true;
          // this.show = false
          Toast.fail("Frequent requests");
        });
    },
    async submitPayment() {
      if (!this.utrValue) {
        Toast.fail("Please enter the UTR.");
        return;
      }
      // if (this.utrValue.length < 10 || this.utrValue.length > 18) {
      //   this.$toast.fail('The length must be between 10-18 digits')
      //   return
      // }
      if (!/^\d{12}$/.test(this.utrValue)) {
        this.$toast.fail(
          "UTR format error:UTR is a 12-digit combination, please check carefully"
        );
        return;
      }

      if (this.showNum == 2) {
        this.h5OrderBuriedPointCreateFun(20);
      } else {
        this.h5OrderBuriedPointCreateFun(21);
      }

      if (this.submitUTRFlag == false) {
        return false;
      }

      this.submitUTRFlag = false;

      h5CheckOutUtrSubmit(
        {
          platOrderId: this.$route.query.orderId,
          utr: this.utrValue,
        },
        this.headers
      )
        .then((res) => {
          this.show = false;
          if (this.toJumpUrl != "") {
            window.open(this.toJumpUrl, "_blank");
          }
          this.status = "wait";
          this.startCountdown();

          this.submitUTRFlag = true;
        })
        .catch((err) => {
          this.submitUTRFlag = true;
          Toast.fail(err.message);
        });
    },

    payOne(num, url) {
      this.utrValue = "";
      if (!this.btnFlag) {
        return false;
      }

      if (num != 3) {
        h5CheckOutClickV2(
          {
            platOrderId: this.$route.query.orderId,
            payMethod: num == 1 ? 2 : num == 9 ? 3 : 1,
          },
          this.headers
        ).then((res) => {
          // if (res.status == 200) {
          // if (num == 1) {
          //   this.showNum = 2
          //   this.showOne = true
          // } else {
          //   if (num == 2) {
          //     this.showNum = 9
          //     this.showOne = true
          //   }
          // }
          // }
        });
      }

      if (url) {
        this.url = url;
      }
      if (num == 9) {
        this.h5OrderBuriedPointCreateFun(10);
        // 记录当前时间
        const startTime = Date.now();
        window.open(this.url, "_blank");
        this.loadingFlag = true;
        // 设置超时检测（移动端通常在1000ms内会跳转成功）
        setTimeout(() => {
          // 如果500ms后页面仍然存在，则认为跳转失败
          this.loadingFlag = false;
          if (Date.now() - startTime > 1000 && !document.hidden) {
            // alert('Failed, APP not installed')
            // Dialog.confirm({
            //   message: 'Failed, APP not installed',
            //   confirmButtonText: 'Yes',
            //   showCancelButton: false,
            // }).then(() => {
            //   // 点击确定时执行
            //   console.log('确认操作')
            // })
          }
        }, 1000);
        return;
      }
      if (num == 3) {
        this.h5OrderBuriedPointCreateFun(13);
        this.showNum = 1;
        this.showOne = true;
        this.manualTransferFlag = false;
      } else {
        if (num == 1) {
          this.h5OrderBuriedPointCreateFun(11);
          this.showNum = 2;
          this.showOne = true;
          this.QRcodeFlag = false;
        } else {
          if (num == 2) {
            this.showNum = 9;
            this.showOne = true;
          }
        }
      }
    },

    setRootFontSize() {
      const baseSize = 16; // 基准字体大小
      const scale = document.documentElement.clientWidth / 375; // 375 为设计稿宽度
      document.documentElement.style.fontSize =
        baseSize * Math.min(scale, 2) + "px"; // 限制缩放倍数
    },

    // 保存图片
    QRCodeBtnsFun() {
      this.payOne(10);
      const image = new Image();
      image.crossOrigin = "Anonymous"; // 允许跨域
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0);

        canvas.toBlob((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "saved_image.jpg"; // 设置下载的文件名
          link.click();

          // 释放内存
          URL.revokeObjectURL(link.href);
        }, "image/jpeg");
      };
      image.src = this.formattedQrCode;

      this.h5OrderBuriedPointCreateFun(12);
    },

    h5OrderBuriedPointCreateFun(num) {
      if (num == 3) {
        this.btnFlag = true;
      }

      if (num == 11 && this.QRcodeFlag == false) {
        return false;
      } else if (num == 13 && this.manualTransferFlag == false) {
        return false;
      } else if (num == 12 && this.saveQRferFlag == false) {
        return false;
      }

      h5OrderBuriedPointCreate(
        {
          platOrderId: this.$route.query.orderId,
          operationType: num,
        },
        this.headers
      ).then((res) => {
        // console.log(res, num)

        if (num == 11) {
          // 点击qrcode弹框打开按钮时候
          this.QRcodeFlag = true;
        } else if (num == 13) {
          // 点击Manual Transfer弹框打开按钮时候
          this.manualTransferFlag = true;
        } else if (num == 12) {
          // 点击保存二维码按钮时候
          this.saveQRferFlag = true;
        }
      });
    },

    // 检测 iOS 设备
    isIOS() {
      return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      );
    },

    copyToClipboard(text) {
      if (this.isIOS()) {
        this.iOSCopyHandler(text);
      } else {
        // 正常处理
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(text)
            .then(() => this.$toast.success("Copied successfully"))
            .catch(() => this.fallbackCopyText(text));
        } else {
          this.fallbackCopyText(text);
        }
      }
    },

    // iOS 专用复制处理器
    iOSCopyHandler(text) {
      // 创建一个可见的临时输入框
      const tempInput = document.createElement("input");
      tempInput.value = text;
      tempInput.style.position = "absolute";
      tempInput.style.left = "-1000px";
      tempInput.style.top = "0";
      document.body.appendChild(tempInput);

      // 选中内容
      tempInput.select();
      tempInput.setSelectionRange(0, 99999);

      try {
        // 尝试执行复制
        const successful = document.execCommand("copy");
        document.body.removeChild(tempInput);

        if (successful) {
          this.$toast.success("Copied successfully");
        } else {
          // 显示提示让用户手动复制
          this.showIOSCopyPrompt(text);
        }
      } catch (err) {
        document.body.removeChild(tempInput);
        this.showIOSCopyPrompt(text);
      }
    },

    // 显示 iOS 复制提示
    showIOSCopyPrompt(text) {
      this.$dialog.alert({
        title: "Copy UPI ID",
        message: `Please select and copy: ${text}`,
        confirmButtonText: "OK",
      });
    },

    copyText(num) {
      setTimeout(() => {
        // Create and append the fake button first
        const fakeBtn = document.createElement("button");
        fakeBtn.className = num == 1 ? "copy-btn" : "iconCopy";
        fakeBtn.style.display = "none";
        document.body.appendChild(fakeBtn);

        // Initialize Clipboard.js after the button exists in DOM
        const clipboard = new Clipboard(fakeBtn, {
          text: () =>
            num == 1 ? this.upiAccount : this.form.orderAmount.toFixed(2),
        });

        clipboard.on("success", (e) => {
          this.$toast.success("Replicating Success!");
          e.clearSelection();
          clipboard.destroy();
          document.body.removeChild(fakeBtn);
        });

        clipboard.on("error", (e) => {
          this.$toast.error("Copy failed!");
          clipboard.destroy();
          document.body.removeChild(fakeBtn);
        });

        // Trigger click after everything is set up
        fakeBtn.click();
      }, 500);
    },
  },
  computed: {
    formattedQrCode() {
      // 动态拼接前缀
      return `data:image/png;base64,${this.form.qrCode}`;
    },
  },
  created() {
    this.h5OrderBuriedPointCreateFun(2);
  },
  mounted() {
    this.getInfo();
    this.intervalStatus = setInterval(() => {
      if (this.statusT != 635) {
        this.getStatus();
        if (this.countdown <= 0) {
          clearInterval(this.intervalStatus);
        }
      }
    }, 3000);

    this.setRootFontSize();

    window.addEventListener("resize", this.setRootFontSize);
  },
  beforeDestroy() {
    var _this = this;

    // 结束时候调取的，但无法正常实现
    window.addEventListener("beforeunload", () => {
      _this.h5OrderBuriedPointCreateFun(30);
    });

    window.removeEventListener("resize", _this.setRootFontSize);
  },

  destroyed() {},
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.payment-page {
  min-height: 100vh;
  background: #f3f3f3;
}

.topT {
  text-align: center;
  margin-bottom: 15px;
}

.topT > div:nth-child(1) {
  font-size: 18px;
  align-items: center;
  color: #212739;
}

.moneyBox {
  width: 100%;
  text-align: center;
}

.moneyBox p:nth-child(1) {
  font-size: 36pt;
  color: #2a50ba;
  margin-bottom: 14px;
  font-weight: bold;
}

.moneyBox p:nth-child(2) {
  font-size: 12pt;
  color: #333333;
  margin-bottom: 30px;
  font-weight: bold;
}

.payBox {
  display: flex;
  justify-content: space-between;
  padding: 18px 14px;
  font-size: 14px;
  border: 1px solid #cacaca;
  border-radius: 5px;
  margin-bottom: 10px;
  align-items: center;
}

.payBoxMIN {
  display: flex;
  justify-content: space-between;
}

.payBox div {
  display: flex;
  align-items: center;
}

.img1 {
  width: 30px;
  height: 30px;
  margin-right: 9px;
}
.img2 {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  margin-right: 2px;
}

.toS {
  height: 12px;
}

.payBtn {
  width: 60px;
  height: 24px;
  font-size: 0.625rem;
  background: #2a50ba;
  border-radius: 12px;
  color: #fff;
  text-align: center;
  line-height: 24px;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.txtBox1 {
  margin-top: 24pt;
  padding: 23pt 12pt 20pt;
  font-size: 14px;
  border: 1px solid #c5c3c3;
  border-radius: 8pt;
  line-height: 26px;
  color: #fc4877;
}

.txtBox2 {
  margin-top: 14pt;
  padding: 23pt 12pt 20pt;
  font-size: 14px;
  border: 1px solid #c5c3c3;
  border-radius: 8pt;
  line-height: 26px;
}

.content {
  padding: 2rem 26px 60px;
}

.showOneTitle {
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.showOneSearch {
  display: flex;
  margin-bottom: 1rem;
}

.showOneCopy {
  width: 4rem;
  background: #2a50ba;
  text-align: center;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border-radius: 5px;
}

.showOneTxt {
  font-size: 12px;
  color: #ff9b00 !important;
  margin-top: 12px;
  margin-bottom: 1.3rem;
  line-height: 16px;
  font-style: italic;
}

.showOneSearchLabel {
  display: flex;
}

.showOneSearchLabel p:nth-child(1) {
  color: #ff0000;
  margin-top: 6.5px;
  margin-left: 6.5px;
}
.showOneSearchLabel p:nth-child(2) {
  font-size: 1rem;
  margin-left: 4px;
}

.btnFun {
  width: 100%;
  background: #2a50ba;
  margin: 20px auto 0;
  height: 44px;
  line-height: 44px;
  color: #fff;
  font-size: 1rem;
  text-align: center;
  border-radius: 1.4rem;
  font-weight: bold;
}

.qrCodeImgs {
  text-align: center;
}

.qrCodeImgs p {
  font-size: 1rem;
  margin-bottom: 14px;
}

.sBox {
  height: 95vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sp {
  margin-top: 20px;
  font-family: Source Sans Variable;
  font-weight: 600;
  font-size: 15px;
  color: #333333;
}
.circle {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dots {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: rotate 2.4s infinite linear;
}

.dot {
  width: 12px;
  height: 12px;
  background-color: #ddd;
  border-radius: 50%;
  position: absolute;
}

.countdown {
  position: absolute;
  font-size: 24px;
  color: red;
  font-weight: bold;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dot-animation {
  0% {
    opacity: 0.3;
    transform: scale(0.7);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.7);
  }
}

.titleMaxBox {
  height: 63px;
  width: 100vw;
  background: #2a50ba;
  display: flex;
  justify-content: space-around;
}

.titleMaxBox div {
  display: flex;
  align-items: center;
}

.titleMaxBox img {
  height: 32px;
}
.titleMaxBox p {
  font-size: 20px;
  font-weight: bold;
  margin-left: 11px;
  color: #fff;
}

.qcBox {
  border: 1px solid #cacaca;
  border-radius: 5px;
  width: 100%;
  text-align: center;
  padding: 24px 0;
  margin-bottom: 22px;
}

.qcBox img {
  width: 175px;
}

.QRCodeBtns {
  width: 145px;
  height: 29px;
  text-align: center;
  line-height: 29px;
  border: 1px solid #cacaca;
  border-radius: 3px;
  margin: auto;
  color: #333333;
  margin-top: 20px;
  font-size: 12px;
}

.payBoxB {
  margin-top: 9px;
  color: #ff9b00 !important;
  line-height: 16px;
  font-size: 10px !important;
}
.btnBox div {
  width: 100%;
  height: 44px;
  border-radius: 22px;
  text-align: center;
  line-height: 44px;
  margin-bottom: 10px;
}
.btnBox div:nth-child(1) {
  text-align: left;
  padding-left: 20px;
  border-radius: 10px;
  background: #f3f3f6;
  color: #a1a1a1;
  margin-bottom: 30px;
}
.btnBox div:nth-child(2) {
  color: #f3f3f6;
  background: #2a50ba;
  font-weight: bold;
}

.txtBoxMax {
  font-size: 12px;
  margin-top: 22px;
  font-weight: bold;
}

.txtBoxMax div {
  display: flex;
}
.txtBoxMax div p {
  line-height: 20px;
  color: #333333;
  margin-bottom: 10px;
}

.txtBoxMax div p:nth-child(1) {
  margin-right: 4px;
}

.dBox {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  padding: 20pt;
  width: 100vw; /* 固定宽度 */
  height: 100vh; /* 固定高度 */
  overflow: auto; /* 自动显示滚动条 */
  z-index: 999999999999999999999999999999999999999999999999999999;
}

.dBox img {
  width: 100%;
}

.nos {
  position: fixed;
  top: 0;
  right: 0;
  width: 36pt;
  height: 36pt;
  border-radius: 18pt;
  text-align: center;
  line-height: 40pt;
  background: #fff;
  font-size: 22px;
}

.dBox p {
  margin: 20px 0;
  font-size: 22px;
}

.topTMax {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  background: #fff;
  padding: 14px;
  border-radius: 10px;
}

.topTMax > div:nth-child(1) {
  font-size: 16px;
  align-items: center;
  color: #333333;
  font-weight: bold;
}

.timer {
  width: 60px;
  border-radius: 20px;
  /* background: #e1e1e2; */
  color: red;
  text-align: center;
}

.mSy {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
}

.mSyTwo {
  font-size: 16px;
  display: block;
  text-align: center;
}

.payTxt {
  background: #f4f9fe;
  color: #5593f3;
  padding: 14px 20px;
  width: 100%;
  margin-bottom: 28px;
}

.test1 {
  color: #da2f2f;
  margin-bottom: 12px;
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.saveQR {
  display: inline-block;
  color: #2a50ba;
  border: 1px solid #2a50ba;
  border-radius: 15px;
  padding: 0px 25px;
  font-size: 12px !important;
  height: 29px;
  line-height: 29px;
}

.mainBox {
  background: #fff;
  border-radius: 10px;
  padding: 32px 14px 26px;
}

.methodBox {
  color: #2a50ba;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 6px;
}
.methodBox span {
  font-size: 0.625rem;
  padding: 4px 4px;
  border-radius: 2px;
}
.payBoxTips {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start !important;
}

.payBoxTips p:nth-child(1) {
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  transform: translateY(-3px);
}
.payBoxTips p:nth-child(2) {
  color: #999999;
  font-size: 9px;
  transform: translateY(3px);
}

.payBtnBox {
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end !important;
}

.payBtnBox p {
  color: #2a50ba;

  font-size: 0.625rem;
}
.payBtnBox span {
  font-weight: bold;
}

.payTMS {
  text-align: center;
  margin-top: 20px;
}
.payTMS img {
  height: 21px;
}

.txtTips {
  background: #fff;
  border-radius: 10px;
  padding: 18px 14px;
  margin-top: 15px;
  font-weight: bold;
}

.txtTips > p {
  color: #111111;
  font-size: 16px;
}

.txtTips > p span {
  display: inline-block;
  background: #848383;
  width: 4px;
  height: 16px;
}

.showOneSearchLabelNews {
  display: flex;
  margin-bottom: 12px;
}
.showOneSearchLabelNews p:nth-child(1) {
  font-size: 14px;
  font-weight: bold;
  margin-right: 2px;
}
.showOneSearchLabelNews p:nth-child(2) {
  font-size: 12px;
}

.showOneSearchTwo /deep/.van-field__control,
.showOneSearch /deep/.van-field__control {
  font-size: 16px;
  text-align: center;
}

.loadingBox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(#ccc, #ccc, #ccc, 0.8);
  top: 0;
  left: 0;
}

/* .pulsing-box {
  animation: pulse 2s infinite ease-in-out;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1) translateY(4px);
  }
  50% {
    transform: scale(0.9) translateY(4px);
  }
} */

.pulsing-box {
  position: relative;
  /* padding: 16px 32px; */
  /* font-size: 18px; */
  font-weight: bold;
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  overflow: hidden;
  z-index: 1;
  transform: scale(0.95);
  animation: pulse 1.5s infinite ease-in-out;
}

.pulsing-box::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 250%;
  background: conic-gradient(
    from 0deg,
    #9c27b0,
    #3f51b5,
    #2196f3,
    #3f51b5,
    #9c27b0
  );
  z-index: -1;
  animation: rotate 3s linear infinite;
}

.pulsing-box::after {
  content: "";
  position: absolute;
  inset: 4px;
  /* background: #2a50ba; */
  border-radius: 48px;
  z-index: -1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(0.95) translateY(4px);
  }
  50% {
    transform: scale(1.05) translateY(4px);
  }
}

.dNone {
  display: none !important;
}

.clickCss {
  cursor: pointer; /* 添加指针样式表示可点击 */
  width: 18px;
  position: absolute;
  left: 50%;
  top: 64%;
  transform: translateX(-9px);
}
</style>
